import { createQueryKeys } from 'query-keys';

export const reportQueryKeys = createQueryKeys('reports', {
  worksites: (params: string) => ({ params }),
  equipments: (params: string) => ({ params }),
  parcels: (params: string) => ({ params }),
  observations: (params: string) => ({ params }),
  drivers: (params: string) => ({ params }),
  driverTracks: (params: string) => ({ params }),
});
